/**
 * Page names and the guided-tour stops for a prospect's demo site (2026-09-28). Used by the
 * footer's "your thoughts on this page" cards and the floating walkthrough recorder, so both name
 * pages the same way.
 */
export const PAGE_NAMES = {
  '/': 'Home',
  '/products': 'Products',
  '/services': 'Services',
  '/events': 'Events',
  '/about': 'About',
  '/contact': 'Contact',
  '/gallery': 'Gallery',
  '/design': 'Design & Order',
  '/print-order': 'Print order',
  '/presentation': 'Presentation',
  '/dashboard': 'Dashboard',
  '/login': 'Log in',
  '/signup': 'Sign up',
  '/account': 'Account',
  '/account/orders': 'My orders',
  '/account/quotes': 'My quotes',
};

export const pageNameFor = (path) =>
  PAGE_NAMES[path] || (path.startsWith('/account/orders/') ? 'Order details' : path.startsWith('/order/') ? 'Your order' : 'this');

/** Stops on the guided tour, in order. `section` stops are skipped if the business has it switched off. */
export const TOUR_STEPS = [
  { path: '/', section: 'hero', always: true, title: '🏠 Your home page', prompt: 'This is what customers see first. What would you want them to notice straight away? Anything you’d change - wording, photos, colours?' },
  { path: '/products', section: 'products', title: '👕 Products', prompt: 'Your garments and prices. Are these the right products? Anything missing, or priced differently to how you’d quote it?' },
  { path: '/design', section: 'design', title: '🎨 Design & order', prompt: 'How a customer builds a custom job and sends artwork. Try it as if you were your customer - where would they get stuck?' },
  { path: '/print-order', section: 'printOrders', title: '⚡ Instant ordering', prompt: 'Small jobs priced and ordered in one go, no quote. Would your customers use this? Which jobs should always need a quote instead?' },
  { path: '/dashboard', always: true, title: '🏭 Your dashboard', prompt: 'Your side: reception checks the quote, the designer approves the artwork, the customer approves a proof, then printing and a final check - and underneath, the supplies you need to order for it all. How does this match how your team really works?' },
  { path: '/presentation', always: true, title: '📣 The proposal', prompt: 'Goals and pricing. Anything you’d want changed, or explained? You can also ask the chat bubble on this page.' },
];
